export function isError403Empty({ title, subtitle, description, backgroundImage, }) {
    return !title || !subtitle || !description || !backgroundImage;
}
